import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/components/ToolStoreUI.css';

const iconPaths = {
  grid: (
    <>
      <rect x="3" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" />
      <rect x="14" y="14" width="7" height="7" rx="1.5" />
    </>
  ),
  bot: (
    <>
      <rect x="4" y="7" width="16" height="12" rx="4" />
      <path d="M9 3h6M12 3v4M8.5 12h.01M15.5 12h.01M8 16h8M2 12h2M20 12h2" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="6.5" />
      <path d="m16 16 5 5" />
    </>
  ),
  flask: (
    <>
      <path d="M9 3h6M10 3v6l-5 8.3A2.4 2.4 0 0 0 7.1 21h9.8a2.4 2.4 0 0 0 2.1-3.7L14 9V3" />
      <path d="M8 15h8M10 12h4" />
    </>
  ),
  building: (
    <>
      <path d="M3 21h18M5 21V10h14v11M3 10h18L12 3 3 10Z" />
      <path d="M8 14v3M12 14v3M16 14v3" />
    </>
  ),
  target: (
    <>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="5" />
      <circle cx="12" cy="12" r="1.5" />
    </>
  ),
  document: (
    <>
      <path d="M6 3h9l4 4v14H6V3Z" />
      <path d="M14 3v5h5M9 13h6M9 17h4" />
    </>
  ),
  chat: (
    <>
      <path d="M4 5h16v12H9l-5 4V5Z" />
      <path d="M8 11h.01M12 11h.01M16 11h.01" />
    </>
  ),
  chart: (
    <>
      <path d="M4 20V9M10 20V4M16 20v-7M22 20H2" />
      <path d="m4 7 6-4 6 7 5-4" />
    </>
  ),
  signal: (
    <>
      <circle cx="12" cy="12" r="2" />
      <path d="M7.8 16.2a6 6 0 0 1 0-8.4M16.2 7.8a6 6 0 0 1 0 8.4M4.2 19.8a11 11 0 0 1 0-15.6M19.8 4.2a11 11 0 0 1 0 15.6" />
    </>
  ),
  route: (
    <>
      <circle cx="6" cy="5" r="2" />
      <circle cx="18" cy="19" r="2" />
      <path d="M8 5h5a4 4 0 0 1 0 8H9a3 3 0 0 0 0 6h7" />
    </>
  ),
  arrow: (
    <>
      <path d="M5 12h14M13 6l6 6-6 6" />
    </>
  ),
  external: (
    <>
      <path d="M14 4h6v6M20 4l-9 9" />
      <path d="M18 13v7H4V6h7" />
    </>
  ),
  lock: (
    <>
      <rect x="5" y="10" width="14" height="11" rx="2" />
      <path d="M8 10V7a4 4 0 0 1 8 0v3M12 14v3" />
    </>
  ),
  close: (
    <>
      <path d="m6 6 12 12M18 6 6 18" />
    </>
  ),
  back: (
    <>
      <path d="M19 12H5M11 18l-6-6 6-6" />
    </>
  ),
  reset: (
    <>
      <path d="M4 4v6h6M4.8 14a8 8 0 1 0 1.5-7.7L4 10" />
    </>
  ),
  sparkles: (
    <>
      <path d="m12 3 1.3 3.7L17 8l-3.7 1.3L12 13l-1.3-3.7L7 8l3.7-1.3L12 3Z" />
      <path d="m19 14 .8 2.2L22 17l-2.2.8L19 20l-.8-2.2L16 17l2.2-.8L19 14ZM5 13l.7 1.8 1.8.7-1.8.7L5 18l-.7-1.8-1.8-.7 1.8-.7L5 13Z" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v6M12 7h.01" />
    </>
  ),
  send: (
    <>
      <path d="m22 2-8 20-4-8-8-4 20-8Z" />
      <path d="M10 14 22 2" />
    </>
  ),
};

export const ToolGlyph = ({ name, size = 24, className = '' }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.7"
    >
      {iconPaths[name] || iconPaths.grid}
    </g>
  </svg>
);

export const ToolStatus = ({ tool }) => (
  <span
    className={`snt-status snt-status--${tool.availability}`}
    aria-label={`Availability: ${tool.availabilityLabel}`}
  >
    <span className="snt-status__dot" aria-hidden="true" />
    {tool.availabilityLabel}
  </span>
);

export const ToolCatalogRow = ({ tool }) => {
  const isUnavailable = tool.availability === 'coming-soon';

  return (
    <article className={`snt-tool-row snt-tool-row--${tool.accent}`}>
      <div className="snt-tool-row__identity">
        <span className="snt-tool-icon" aria-hidden="true">
          <ToolGlyph name={tool.icon} size={25} />
        </span>
        <div>
          <h3>{tool.title}</h3>
          <p>{tool.description}</p>
        </div>
      </div>

      <dl className="snt-tool-row__meta">
        <div>
          <dt>Type</dt>
          <dd>
            <span className="snt-type-pill">{tool.type}</span>
          </dd>
        </div>
        <div>
          <dt>Availability</dt>
          <dd>
            <ToolStatus tool={tool} />
          </dd>
        </div>
      </dl>

      <div className="snt-tool-row__action">
        {isUnavailable ? (
          <button type="button" disabled>
            {tool.actionLabel}
          </button>
        ) : (
          <Link to={`/supernova-tools/${tool.slug}`}>
            {tool.actionLabel}
            <ToolGlyph name="arrow" size={18} />
          </Link>
        )}
      </div>
    </article>
  );
};

export const ToolRowSkeleton = () => (
  <div className="snt-tool-row snt-tool-row--skeleton" aria-hidden="true">
    <span className="snt-skeleton snt-skeleton--icon" />
    <div className="snt-skeleton-stack">
      <span className="snt-skeleton snt-skeleton--title" />
      <span className="snt-skeleton snt-skeleton--copy" />
    </div>
    <span className="snt-skeleton snt-skeleton--meta" />
    <span className="snt-skeleton snt-skeleton--button" />
  </div>
);
